export const BURN_IN_JOB_STATUS_OPEN = "OPEN";
export const BURN_IN_JOB_STATUS_BUSY = "BUSY";
export const BURN_IN_JOB_STATUS_DONE = "DONE";
